import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {filter, map} from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import {AccountService} from "../../services";
import {Discounts} from "../model/discounts";
import {Discount} from "../model/discount";
import {Order} from "../../models/order";

@Injectable({ providedIn: 'root' })
export class DiscountService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    getAll(offset: number, limit: number) {

        return this.http.get<Discounts>(`${environment.apiEndpoint}/v1/discounts?offset=`+offset+`&limit=`+limit, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getActive() {

        return this.http.get<Discounts>(`${environment.apiEndpoint}/v1/discounts/active/all`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getById(id: string) {
        return this.http.get<Discount>(`${environment.apiEndpoint}/v1/discounts/${id}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    update(id, params) {
        return this.http.put(`${environment.apiEndpoint}/v1/discounts/${id}`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: Discount) => {
                return x;
            }));
    }

    create(params) {
        return this.http.post(`${environment.apiEndpoint}/v1/discounts`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: Discount) => {
                return x;
            }));
    }

    recalculate(params) {
        return this.http.post(`${environment.apiEndpoint}/v1/discounts/recalculate-receipt`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: Order) => {
                return x;
            }));
    }

    delete(id: string) {
        return this.http.delete(`${environment.apiEndpoint}/v1/discounts/` + id, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }
}
